module.exports = __webpack_public_path__ + "img/FNB-Logo.4e004f2c.svg";